export default "__VITE_ASSET__DpGhMDln__"